import ComingSoon from 'components/@client/ComingSoon/ComingSoon';

const Help = () => {
  return <ComingSoon />;
};

export default Help;
